module.exports = __webpack_public_path__ + "static/media/1016854.96eac359.jpg";